export async function fetch({ state, commit }, { id, api, ctx = "" }) {
  const inflightKey = `${ctx}::${id}`;
  if (state.inflight[inflightKey]) return state.inflight[inflightKey];

  const p = api(id)
    .then((item) => {
      commit("set", { id, item, ctx });
      return item;
    })
    .finally(() => commit("clearInflight", inflightKey));

  commit("setInflight", { id: inflightKey, p });
  return p;
}
